import { ModelEntity } from '../implementations/model.entity';
import { ICredentialsEntity } from './authentication.interfaces';

export class CredentialsEntity extends ModelEntity implements ICredentialsEntity {

    protected _email: string = null;
    protected _password: string = null;
    protected _username: string = null;

    constructor(initValues: Partial<ICredentialsEntity> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get password(): string {
        return this._password;
    }

    public set password(value: string) {
        this._password = value;
    }

    public get username(): string {
        return this._username;
    }

    public set username(value: string) {
        this._username = value;
    }

}
